<div class="banner step-banner accidents-happen-banner">

  <div class="step-banner__left">
    <div class="step-banner__left__image">
      <img [src]="leftImageSrc" alt="">
    </div>
    <div class="step-banner__left__text">
      <div class="step-banner__left__text__header">
        {{ 'BANNER.ACCIDENTS_HAPPEN.header' | translate }}
      </div>
      <div  class="step-banner__left__text__description"
            [innerHTML]="'BANNER.ACCIDENTS_HAPPEN.description' | translate | safeHtml">
      </div>
    </div>
  </div>

  <div class="step-banner__button">
    <button (click)="openPopup()" class="btn btn--secondary">
      {{ 'BANNER.ACCIDENTS_HAPPEN.buttonText' | translate }}
    </button>
  </div>

  <div class="step-banner__logo-sos">
    <img [src]="logoSos" alt="">
  </div>

</div>
